import React, { Fragment, useContext, useEffect, useState } from "react";
import {
  Card,
  Col,
  Container,
  CardBody,
  CardTitle,
  Row,
  Button,
  Badge,
  Label,
  CardText,
} from "reactstrap";
import { Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  saveFavoriteJobRequest,
  resetFavoriteMessage,
} from "../../../redux/jobseeker/favorite_job/actions";
import {
  fetchJobDetails,
  applyJobRequest,
  resetMessage,
} from "../../../redux/jobdetails/actions";
import {
  jobSharingRequest,
  resetJobSharingMessage,
} from "../../../redux/job_sharing/actions";
import {
  joinGroupRequest,
  joinGroupReset,
} from "../../../redux/join_group/actions";
import { useNavigate } from "react-router-dom";
import { FaRegBuilding } from "react-icons/fa";
import { RiMenu2Line } from "react-icons/ri";
import { IoSchoolOutline } from "react-icons/io5";
import { IoExtensionPuzzleOutline } from "react-icons/io5";
import { IoLocationOutline } from "react-icons/io5";
import { LuClock3 } from "react-icons/lu";
import { MdCurrencyRupee } from "react-icons/md";
import { FaArrowRight } from "react-icons/fa";
import { BsSuitcaseLg } from "react-icons/bs";
import { IoDocumentTextOutline } from "react-icons/io5";
import { BsFillFlagFill, BsBookmarkFill, BsChatFill } from "react-icons/bs";
import { PreloaderContext } from "../../../_helper/Preloader/PreloaderContext";
import { showToast } from "../../Common/Toast";
import { LOADER_TIMEOUT } from "../../../Constant";
import Spinner from "../../Common/Spinner";
import {
  submitReportRequest,
  resetReportJobData,
} from "../../../redux/jobseeker/report_job/actions";
import { formatDate, convertMonthsToYears } from "../../Common/CommonFunction";
import { AuthContext } from "../../../Auth/AuthContext";
import { removeHTMLTags, parseHtmlBenefits } from "../../Common/CommonFunction";
import { jobTypeOptions, SYSTEM_NAME, shiftTypeOptions } from "../../../Constant";

import {
  formatExperienceOutput,
  capitalize,
  extractAfterLastHyphen,
} from "../../Common/CommonFunction";

import {
  formatSalaryOutput,
  hasPositiveSalaryRange,
} from "../../Common/CommonFunction";
import { FaCheckCircle, FaLock, FaWhatsapp, FaEnvelope, FaExclamationCircle, FaShieldAlt } from "react-icons/fa";
import { FiStar } from "react-icons/fi";
import whatsapp from "..//../../assets/images/Icons/whatsapp.png";
import facebook from "../../../assets/images/Icons/facebook.png";
import twitter from "../../../assets/images/Icons/twitter.png";
import linkedin from "../../../assets/images/Icons/linkedin.png";
import NoDataFound from "../../Common/NoDataFound";
import instagram from "../../../assets/images/Icons/instagram.png";
import { benefitsOptions } from "../../../Constant";
import { employmentTypeOptions } from "../../../Constant";
import { GrLocation } from "react-icons/gr";
import { PiSuitcaseSimple } from "react-icons/pi";
const JobDetails = () => {
  const { user, triggerTotalPoints } = useContext(AuthContext);

  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate();
  const { showPreloader } = useContext(PreloaderContext);
  const jobReducerData = useSelector((state) => state.jobDetailsReducer);

  const jobData = jobReducerData.data;


  const [rating, setRating] = useState("");
  const [companyLogoLoadError, setCompanyLogoLoadError] = useState(false);
  const referralLink = `${window.location.origin}${process.env.PUBLIC_URL}/public/job_details/${id}`;
  // const referralLink = `https://www.google.com`;
  const shareOnSocialMedia = (platform) => {
    // Logic to share referral link on selected social media platform
    let shareUrl = "";
    switch (platform) {
      case "whatsapp":
        shareUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(
          `Xyntara | Job apply link – ${referralLink}`
        )}`;
        break;
      case "facebook":
        shareUrl = `https://www.facebook.com/sharer.php?u=${encodeURIComponent(
          referralLink
        )}`;
        break;
      case "twitter":
        shareUrl = `http://twitter.com/share?url=${encodeURIComponent(
          referralLink
        )}`;
        break;
      case "linkedin":
        shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
          referralLink
        )}`;
        break;
      case "instagram":
        shareUrl = `https://www.instagram.com/`; // Instagram sharing URL (placeholder)
        alert(
          "Instagram sharing requires the mobile app or deeper integration. Redirecting to Instagram."
        );
        break;
      default:
        break;
    }
    dispatch(
      jobSharingRequest({
        job_id: extractAfterLastHyphen(id),
        platform,
      })
    );
    setTimeout(() => {
      window.open(shareUrl, "_blank"); // Open the share URL in a new tab
    }, 2000); // Delay of 2 seconds (2000 milliseconds)
  };

  useEffect(() => {

    dispatch(fetchJobDetails({ job_id: extractAfterLastHyphen(id) }));
  }, []);

  useEffect(() => {
    if (jobReducerData.status == true && jobReducerData.message != "") {
      showToast("success", jobReducerData.message);
      triggerTotalPoints("appling_jobs", false);
      // Dispatch action to reset the message after showing the toast
      dispatch(resetMessage());
      navigate(`${process.env.PUBLIC_URL}/jobseeker/applied_Jobs`);
      // Reset form data
    } else if (jobReducerData.status == false && jobReducerData.message != "") {
      if (showPreloader) {
        setTimeout(() => {
          showToast("error", jobReducerData.message);
        }, LOADER_TIMEOUT);
      } else {
        showToast("error", jobReducerData.message);
      }

      // Dispatch action to reset the message after showing the toast
      dispatch(resetMessage());
    }
  }, [jobReducerData]);

  const handleApplyNow = () => {
    // Dispatch action to apply job
    console.log("jobData", jobData.job_external_url);
    if (jobData.job_external_url) {
      window.open(jobData.job_external_url, "_blank");
    } else {
      const data = {
        job_id: extractAfterLastHyphen(id),
        recruiter_id: jobData.recruiter_id,
        company_id: jobData.company_id,
      };
      dispatch(applyJobRequest(data));
    }


  };

  const handleReportJobClick = () => {
    const formattedData = {
      job_id: extractAfterLastHyphen(id),
    };

    navigate(`${process.env.PUBLIC_URL}/public/report_job/${id}`);
  };

  const reportJobReducerData = useSelector((state) => state.reportJobReducer);
  useEffect(() => {
    if (reportJobReducerData.status && reportJobReducerData.message != "") {
      showToast("success", reportJobReducerData.message);

      dispatch(resetReportJobData());
    } else if (
      reportJobReducerData.status == false &&
      reportJobReducerData.message != ""
    ) {
      showToast("error", reportJobReducerData.message);

      dispatch(resetReportJobData());
    }
  }, [reportJobReducerData]);

  const handleFavouriteJobClick = () => {
    if (user.isLoggedin) {
      dispatch(saveFavoriteJobRequest({ job_id: extractAfterLastHyphen(id) }));
    } else {
      // User is not logged in, navigate to the login page
      navigate(`${process.env.PUBLIC_URL}/auth/login`); // Use navigate for navigation
    }
  };

  const handleFeedbackJobClick = () => {
    if (user.isLoggedin) {
      navigate(`${process.env.PUBLIC_URL}/jobseeker/job_feedback/${id}`); // Use navigate for navigation
    } else {
      // User is not logged in, navigate to the login page
      navigate(`${process.env.PUBLIC_URL}/auth/login`); // Use navigate for navigation
    }
  };

  const favoriteJobReducerData = useSelector(
    (state) => state.favoriteJobReducer
  );
  useEffect(() => {
    if (favoriteJobReducerData.status && favoriteJobReducerData.message != "") {
      showToast("success", favoriteJobReducerData.message);

      dispatch(resetFavoriteMessage());

      navigate(`${process.env.PUBLIC_URL}/jobseeker/saved_jobs`);
    } else if (
      favoriteJobReducerData.status == false &&
      favoriteJobReducerData.message != ""
    ) {
      showToast("error", favoriteJobReducerData.message);

      dispatch(resetFavoriteMessage());
    }
  }, [favoriteJobReducerData]);

  const jobSharingReducerData = useSelector((state) => state.jobSharingReducer);
  console.log("jobSharingReducerData", jobSharingReducerData);
  useEffect(() => {
    if (jobSharingReducerData.status && jobSharingReducerData.message != "") {
      // showToast("success", jobSharingReducerData.message);
      triggerTotalPoints("share_jobs");
      dispatch(resetJobSharingMessage());
    } else if (
      jobSharingReducerData.status == false &&
      jobSharingReducerData.message != ""
    ) {
      showToast("error", jobSharingReducerData.message);

      dispatch(resetJobSharingMessage());
    }
  }, [jobSharingReducerData]);

  const joinInGroup = (groupType, url) => {
    const formattedData = {
      url: url,
      group_type: groupType,
    };

    dispatch(joinGroupRequest(formattedData));
  };

  const joinGroupReducerData = useSelector((state) => state.joinGroupReducer);
  useEffect(() => {
    if (joinGroupReducerData.status && joinGroupReducerData.message != "") {
      if (joinGroupReducerData.type) {
        triggerTotalPoints(joinGroupReducerData.type);
      }
      dispatch(joinGroupReset());
    } else if (
      joinGroupReducerData.status == false &&
      joinGroupReducerData.message != ""
    ) {
      showToast("error", joinGroupReducerData.message);

      dispatch(joinGroupReset());
    }
  }, [joinGroupReducerData]);

  const hasExternalUrl = Boolean(jobData?.job_external_url?.trim?.());
  const isInternalJob = jobData?.job_source === "INTERNAL";
  const hasManualContact = Boolean(jobData?.company_email);

  const showInternalApply = isInternalJob && !hasExternalUrl;
  const showExternalApply = !isInternalJob && hasExternalUrl;
  const showManualApply = !isInternalJob && !hasExternalUrl && hasManualContact;

  useEffect(() => {
    setCompanyLogoLoadError(false);
  }, [jobData?.job_id, jobData?.company_logo]);

  return (
    <Fragment>
      <Container fluid={true}>
        {!jobReducerData.isLoading && jobData ? (
          <Row className="mb-5">
            <Col md={7}>
              <Card>
                <CardBody>
                  {showManualApply && (
                    <div 
                      className="p-3 rounded border mb-4" 
                      style={{ 
                        background: "rgba(115, 102, 255, 0.05)", 
                        borderColor: "rgba(115, 102, 255, 0.2)",
                        fontSize: "0.9rem",
                        lineHeight: 1.5,
                        boxShadow: "0 4px 15px rgba(115, 102, 255, 0.05)",
                        backdropFilter: "blur(5px)"
                      }}
                    >
                      <div className="fw-bold mb-2 d-flex align-items-center" style={{ color: "#7366ff" }}>
                        <span className="me-2" style={{ fontSize: "1.2rem" }}>⚡</span>
                        To Apply for this Job:
                      </div>
                      
                      <div className="d-flex flex-wrap gap-3">
                        {jobData.company_email && (
                          <div className="d-flex align-items-center bg-white p-2 rounded border" style={{ minWidth: "220px", borderColor: "rgba(0,0,0,0.08)" }}>
                            <div className="d-flex align-items-center justify-content-center bg-primary text-white rounded-circle me-2" style={{ width: "32px", height: "32px" }}>
                              <FaEnvelope style={{ fontSize: "15px" }} />
                            </div>
                            <div>
                              <div className="text-muted" style={{ fontSize: "0.75rem" }}>Email Resume</div>
                              <a
                                href={`mailto:${jobData.company_email}`}
                                className="fw-semibold text-dark text-decoration-none hover-primary"
                                style={{ transition: "color 0.2s" }}
                              >
                                {jobData.company_email}
                              </a>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  <div className="media">
                    <div className="media-body">
                      <h4 className="f-w-500 text-capitalize me-3 mb-0 d-flex flex-wrap align-items-center gap-2">
                        <a
                          href="#javascript"
                          style={{
                            display: "block",
                            overflowWrap: "break-word",
                          }}
                        >
                          {capitalize(jobData.job_name)}
                        </a>
                        {jobData?.job_source?.toLowerCase() === "telegram" ? (
                          <Badge
                            color="none"
                            style={{
                              background: "linear-gradient(135deg, rgba(239, 68, 68, 0.1), rgba(220, 38, 38, 0.15))",
                              color: "#dc2626",
                              border: "1px solid rgba(239, 68, 68, 0.25)",
                              borderRadius: "30px",
                              padding: "4px 10px",
                              fontSize: "0.75rem",
                              fontWeight: "600",
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "5px",
                              textTransform: "capitalize",
                              boxShadow: "0 2px 4px rgba(239, 68, 68, 0.05)",
                            }}
                          >
                            <FaExclamationCircle size={12} style={{ color: "#ef4444" }} />
                            Unverified
                          </Badge>
                        ) : (
                          <Badge
                            color="none"
                            style={{
                              background: "linear-gradient(135deg, rgba(16, 185, 129, 0.1), rgba(5, 150, 105, 0.15))",
                              color: "#059669",
                              border: "1px solid rgba(16, 185, 129, 0.25)",
                              borderRadius: "30px",
                              padding: "4px 10px",
                              fontSize: "0.75rem",
                              fontWeight: "600",
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "5px",
                              textTransform: "capitalize",
                              boxShadow: "0 2px 4px rgba(16, 185, 129, 0.05)",
                            }}
                          >
                            <FaCheckCircle size={12} style={{ color: "#10b981" }} />
                            Verified
                          </Badge>
                        )}
                      </h4>

                      {jobData?.job_source?.toLowerCase() !== "telegram" && (
                        <span
                          className="me-2 d-flex align-items-center  f-w-500 "
                          style={{ minHeight: "1em" }}
                        >
                          {/* <FaRegBuilding
                              size={16}
                              className="me-1"
                              style={{ color: "green" }}
                            /> */}
                          <span className="me-1">
                            {jobData.company_name &&
                              capitalize(jobData.company_name)}
                          </span>
                          {jobData.average_rating && (
                            <div className="stars me-2 icon-container ">
                              {[...Array(5)].map((_, i) => {
                                const starValue = i + 1;
                                const averageRating =
                                  jobData.average_rating ?? "";
                                return (
                                  <span
                                    key={starValue}
                                    className=""
                                    style={{
                                      cursor: "pointer",
                                      color:
                                        starValue <= averageRating
                                          ? "orange"
                                          : "gray",
                                      fontSize: "calc(0.8em + 0.5vw)",
                                    }}
                                  >
                                    &#9733;
                                  </span>
                                );
                              })}
                            </div>
                          )}
                        </span>
                      )}
                      <p
                        className=" d-flex align-items-center flex-wrap  f-w-500"
                        style={{ color: "#121224", minHeight: "3em" }} // Adjust minHeight as needed
                      >
                        <span className=" d-flex align-items-center">
                          <PiSuitcaseSimple
                            size={19}
                            className="me-1 suit-case-icon"
                          />
                          {jobData.work_experience_min ||
                            jobData.work_experience_max ? (
                            <div className="mb-0 d-flex align-items-center">
                              <span>
                                {formatExperienceOutput(
                                  jobData.work_experience_min,
                                  jobData.work_experience_max
                                )}
                              </span>
                            </div>
                          ) : (
                            "N/A"
                          )}
                        </span>
                        <span className="mx-2">|</span>{" "}
                        {jobData.is_disclose_salary == 1 ? (
                          <span className="me-2 mb-0 d-flex align-items-center">
                            <MdCurrencyRupee
                              className="me-1 rupee-icon"
                              size={18}
                            />
                            {hasPositiveSalaryRange(
                              jobData.salary_min,
                              jobData.salary_max
                            )
                              ? formatSalaryOutput(
                                  jobData.salary_min,
                                  jobData.salary_max
                                )
                              : "Not disclosed"}
                          </span>
                        ) : (
                          <span className="me-2 mb-0 d-flex align-items-center">
                            <MdCurrencyRupee
                              className="me-1 rupee-icon"
                              size={18}
                            />
                            Not disclosed
                          </span>
                        )}
                        <span className="mx-2">|</span>{" "}
                        <span className="d-flex align-items-center">
                          <GrLocation
                            size={19}
                            className="me-1 location-icon"
                          />
                          {jobData.job_location
                            ? capitalize(jobData.job_location)
                            : "N/A"}
                        </span>
                      </p>
                    </div>

                    {(showInternalApply || showExternalApply) && (
                      <Button
                        color="primary"
                        className="mt-1 d-flex align-items-center ps-3 pe-3"
                        onClick={handleApplyNow}
                        disabled={jobData.job_applied_status}
                      >
                        {jobData.job_applied_status ? (
                          <>
                            <FaLock size="18px" className="me-2" />
                            Already Applied
                          </>
                        ) : (
                          <>
                            <FaCheckCircle size="18px" className="me-2" />
                            {showExternalApply
                              ? "Apply on External Site"
                              : "Apply Now"}
                          </>
                        )}
                      </Button>
                    )}

                  </div>

                  <div className="mt-4">
                    <h5 style={{ display: "flex", alignItems: "center" }}>
                      <RiMenu2Line style={{ marginRight: "5px" }} /> Job Details
                    </h5>
                    <div className="mt-3">
                      {jobData.no_of_positions && (
                        <CardText>
                          <strong>Vacancy: </strong> {jobData.no_of_positions}
                        </CardText>
                      )}
                      {jobData.industry_area && (
                        <CardText>
                          <strong>Industry Type:</strong>{" "}
                          {jobData.industry_area}
                        </CardText>
                      )}

                      {jobData.functional_area_type && (
                        <CardText>
                          <strong>Functional Area:</strong>{" "}
                          {jobData.functional_area_type}
                        </CardText>
                      )}

                      {jobData.job_shift && (
                        <CardText>
                          <strong>Shift Type:</strong>{" "}
                          {(() => {
                            const jobType = shiftTypeOptions.find(
                              (option) => option.value === jobData.job_shift
                            );
                            return jobType ? jobType.label : "Unknown"; // Assuming jobTypeOptions have a 'label' property
                          })()}
                        </CardText>
                      )}

                      {jobData.employment_type && (
                        <CardText>
                          <strong>Employment Type:</strong>{" "}
                          {(() => {
                            const employmentType = employmentTypeOptions.find(
                              (option) =>
                                option.value === jobData.employment_type
                            );
                            return employmentType
                              ? employmentType.label
                              : "Unknown"; // Assuming employmentTypeOptions have a 'label' property
                          })()}
                        </CardText>
                      )}

                      {jobData.updated_at && (
                        <CardText>
                          <strong>Published on:</strong>{" "}
                          {formatDate(jobData.updated_at)}
                        </CardText>
                      )}

                      {jobData.job_last_date && (
                        <CardText>
                          <strong>Application Deadline:</strong>
                          {""} {formatDate(jobData.job_last_date)}
                        </CardText>
                      )}

                      {jobData.hit && (
                        <CardText>
                          <strong>Job Views:</strong> {jobData.hit}
                        </CardText>
                      )}
                    </div>
                  </div>

                  {jobData.job_description && (
                    <div className="mt-4">
                      <h5 style={{ display: "flex", alignItems: "center" }}>
                        <IoDocumentTextOutline style={{ marginRight: "5px" }} />{" "}
                        Job Description
                      </h5>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: jobData.job_description,
                        }}
                      >
                        {/* {removeHTMLTags(jobData.job_description)} */}
                        {/* {jobData.job_description} */}
                      </div>
                    </div>
                  )}
                  <hr />
                  <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3">

                    {/* Buttons Section */}
                    <div className="d-flex flex-wrap flex-md-nowrap gap-2">
                      <Button
                        size="md"
                        color="primary"
                        className={`d-flex align-items-center ps-3 pe-3 `}
                        onClick={handleFavouriteJobClick}
                      // disabled={jobData.is_saved}
                      >
                        <BsBookmarkFill className="me-1" />
                        {jobData.is_saved ? "Unsave" : "Save"}
                      </Button>

                      <Button
                        color="primary"
                        className="d-flex align-items-center ps-3 pe-3"
                        onClick={handleFeedbackJobClick}
                      >
                        <BsChatFill className="me-1" /> Feedback
                      </Button>

                      <Button
                        color="primary"
                        className="d-flex align-items-center ps-3 pe-3"
                        onClick={handleReportJobClick}
                      >
                        <BsFillFlagFill className="me-1" /> Report
                      </Button>
                    </div>

                    {/* Social Share Icons */}
                    <div className="d-flex flex-wrap align-items-center gap-2">
                      <span className="me-1">Share:</span>

                      <img
                        src={whatsapp}
                        className="share-link share_refferal"
                        onClick={() => shareOnSocialMedia("whatsapp")}
                        aria-label="Whatsapp"
                        alt="whatsapp"
                        style={{ width: "25px", height: "25px", cursor: "pointer" }}
                        title="Share on Whatsapp"
                      />
                      <img
                        src={facebook}
                        className="share-link share_refferal"
                        onClick={() => shareOnSocialMedia("facebook")}
                        aria-label="Facebook"
                        alt="facebook"
                        style={{ width: "25px", height: "25px", cursor: "pointer" }}
                        title="Share on Facebook"
                      />
                      <img
                        src={twitter}
                        className="share-link share_refferal"
                        onClick={() => shareOnSocialMedia("twitter")}
                        aria-label="Twitter"
                        alt="twitter"
                        style={{ width: "25px", height: "25px", cursor: "pointer" }}
                        title="Share on Twitter"
                      />
                      <img
                        src={linkedin}
                        className="share-link share_refferal"
                        onClick={() => shareOnSocialMedia("linkedin")}
                        aria-label="Linkedin"
                        alt="linkedin"
                        style={{ width: "25px", height: "25px", cursor: "pointer" }}
                        title="Share on Linkedin"
                      />
                      <img
                        src={instagram}
                        className="share-link share_refferal"
                        onClick={() => shareOnSocialMedia("instagram")}
                        aria-label="Instagram"
                        alt="instagram"
                        style={{ width: "25px", height: "25px", cursor: "pointer" }}
                        title="Share on Instagram"
                      />
                    </div>
                  </div>

                </CardBody>
              </Card>
              {jobData.qualifications && (
                <Card>
                  <CardBody>
                    <h5 style={{ display: "flex", alignItems: "center" }}>
                      <IoSchoolOutline style={{ marginRight: "5px" }} />{" "}
                      Education (Minimum Qualification)
                    </h5>
                    <ul
                      className="mt-3"
                      style={{ listStyleType: "disc", paddingLeft: "20px" }}
                    >
                      {jobData.qualifications
                        .split(",")
                        .map((qualification, index) => (
                          <li key={index}>{qualification.trim()}</li>
                        ))}
                    </ul>
                  </CardBody>
                </Card>
              )}

              {jobData.mandatory_skills && (
                <Card>
                  <CardBody>
                    <h5 style={{ display: "flex", alignItems: "center" }}>
                      <IoExtensionPuzzleOutline
                        style={{ marginRight: "5px" }}
                      />{" "}
                      Skills Required
                    </h5>
                    <div className="mt-4">
                      {jobData.mandatory_skills && (
                        <div className="mt-2">
                          <strong className="mb-2">Mandatory Skills</strong>

                          {jobData.mandatory_skills && (
                            <div>
                              {jobData.mandatory_skills
                                .split(",")
                                .map((skill) => skill.trim())
                                .sort((a, b) =>
                                  a === jobData.primary_skill
                                    ? -1
                                    : b === jobData.primary_skill
                                      ? 1
                                      : 0
                                ) // Sort to ensure primary skill is first
                                // .slice(0, 3)
                                .map((skill, index) => {
                                  const isPrimary =
                                    skill === jobData.primary_skill; // Check if current skill is primary
                                  return (
                                    <Badge
                                      key={index}
                                      className={`me-2 mb-2 border rounded  ${isPrimary
                                        ? "fw-bolder text-primary"
                                        : "text-black"
                                        }`}
                                      color="gray"
                                      pill
                                    >
                                      {skill}
                                      {isPrimary && (
                                        <FiStar
                                          style={{
                                            marginLeft: "5px",
                                            color: "blue", // Example: Change star color for primary skill
                                          }}
                                        />
                                      )}
                                    </Badge>
                                  );
                                })}
                            </div>
                          )}
                        </div>
                      )}

                      {jobData.good_to_have_skills && (
                        <div className="mt-2">
                          <strong className="mb-2">Good to Have Skills</strong>
                          <div>
                            {jobData.good_to_have_skills
                              .split(",")
                              .map((skill, index) => (
                                <Badge
                                  className="me-2 mb-2 border rounded text-black"
                                  color="gray"
                                  pill
                                >
                                  {skill.trim()}
                                </Badge>
                              ))}
                          </div>
                        </div>
                      )}
                    </div>
                  </CardBody>
                </Card>
              )}

              {(() => {
                const parsedBenefits = parseHtmlBenefits(jobData.job_benefits, benefitsOptions);
                return parsedBenefits.length > 0 ? (
                  <Card>
                    <CardBody>
                      <h5 style={{ display: "flex", alignItems: "center" }}>
                        <IoDocumentTextOutline style={{ marginRight: "5px" }} />{" "}
                        Benefits
                      </h5>
                      <ul className="mt-3" style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                        {parsedBenefits.map((benefit, index) => (
                          <li key={index}>{benefit}</li>
                        ))}
                      </ul>
                    </CardBody>
                  </Card>
                ) : null;
              })()}
            </Col>
            <Col md={5}>
              {jobData?.job_source?.toLowerCase() !== "telegram" && (
                <Card>
                  <CardBody>
                    <h5 style={{ display: "flex", alignItems: "center" }}>
                      <FaRegBuilding style={{ marginRight: "5px" }} /> Company
                      Overview
                    </h5>
                    <Row className="mt-4">
                      <Col xs="auto">
                        {jobData.company_logo && !companyLogoLoadError ? (
                          <img
                            src={jobData.company_logo}
                            alt="Company Logo"
                            style={{ width: "100px", objectFit: "contain" }}
                            className="img-responsive rounded"
                            onError={() => setCompanyLogoLoadError(true)}
                          />
                        ) : (
                          <div className="company_name_bg">
                            {jobData.company_name &&
                            String(jobData.company_name).trim()
                              ? String(jobData.company_name)
                                  .trim()
                                  .charAt(0)
                                  .toUpperCase()
                              : "?"}
                          </div>
                        )}
                      </Col>
                      <Col>
                        <div className="company-info text-capitalize">
                          <h6>{capitalize(jobData.company_name)}</h6>
                          <p className="mb-0">{jobData.address}</p>
                          {jobData.company_website && (
                            <p className="mb-0">
                              <a
                                href={`https://${jobData.company_website}`}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Visit website
                              </a>
                            </p>
                          )}
                          <p>{jobData.jobs_count} Current Jobs Openings</p>
                        </div>
                        <div className="d-flex align-items-center mt-2">
                          {/* <span>Share: &nbsp;&nbsp;</span> */}
                          {jobData.company_facebook_url && (
                            <Link
                              to={jobData.company_facebook_url}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                src={facebook}
                                className="share-link share_refferal me-2"
                                aria-label="Facebook"
                                alt="facebook"
                                style={{
                                  width: "25px",
                                  height: "25px",
                                  cursor: "pointer",
                                }}
                                title="Share on Facebook"
                              />
                            </Link>
                          )}
                          {jobData.company_twitter_url && (
                            <Link
                              to={jobData.company_twitter_url}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                src={twitter}
                                className="share-link share_refferal me-2"
                                aria-label="Twitter"
                                alt="twitter"
                                style={{
                                  width: "25px",
                                  height: "25px",
                                  cursor: "pointer",
                                }}
                                title="Share on Twitter"
                              />
                            </Link>
                          )}
                          {jobData.company_linkedin_url && (
                            <Link
                              to={jobData.company_linkedin_url}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                src={linkedin}
                                className="share-link share_refferal me-2"
                                aria-label="Linkedin"
                                alt="linkedin"
                                style={{
                                  width: "25px",
                                  height: "25px",
                                  cursor: "pointer",
                                }}
                                title="Share on Linkedin"
                              />
                            </Link>
                          )}
                          {jobData.company_instagram_url && (
                            <Link
                              to={jobData.company_instagram_url}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                src={instagram}
                                className="share-link share_refferal "
                                aria-label="Instagram"
                                alt="instagram"
                                style={{
                                  width: "25px",
                                  height: "25px",
                                  cursor: "pointer",
                                }}
                                title="Share on Instagram"
                              />{" "}
                            </Link>
                          )}
                        </div>
                      </Col>
                    </Row>

                    {jobData.company_about && (
                      <div>
                        <hr />
                        <p className="company-about text-justify mb-1">
                          {jobData.company_about}
                        </p>
                        {jobData.company_website && (
                          <a
                            target="_blank"
                            href={`https://${jobData.company_website}`}
                          >
                            Read More
                          </a>
                        )}
                      </div>
                    )}
                  </CardBody>
                </Card>
              )}

              {jobData?.job_source?.toLowerCase() === "telegram" ? (
                <div
                  style={{
                    marginTop: "16px",
                    marginBottom: "24px",
                    padding: "16px",
                    background: "linear-gradient(135deg, rgba(115, 102, 255, 0.05) 0%, rgba(115, 102, 255, 0.08) 100%)",
                    border: "1px solid rgba(115, 102, 255, 0.2)",
                    borderLeft: "4px solid #7366ff",
                    borderRadius: "14px",
                    color: "#4e41e5",
                    fontSize: "0.88rem",
                    lineHeight: "1.5",
                    boxShadow: "0 2px 10px rgba(115, 102, 255, 0.04)",
                  }}
                  role="alert"
                >
                  <div style={{ display: "flex", gap: "10px", alignItems: "flex-start" }}>
                    <FaExclamationCircle size={18} style={{ color: "#7366ff", flexShrink: 0, marginTop: "2px" }} />
                    <div>
                      <strong style={{ fontWeight: "700" }}>Community Source Alert:</strong> This job has been aggregated from open public channels/communities. Please verify all details independently. <strong style={{ color: "#d93838", fontWeight: "700" }}>Never pay any fee, security deposit, or processing fee</strong> to any employer. If anyone asks you for money, report the job immediately.
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  style={{
                    marginTop: "16px",
                    marginBottom: "24px",
                    padding: "16px",
                    background: "linear-gradient(135deg, rgba(217, 119, 6, 0.05) 0%, rgba(217, 119, 6, 0.08) 100%)",
                    border: "1px solid rgba(217, 119, 6, 0.2)",
                    borderLeft: "4px solid #d97706",
                    borderRadius: "14px",
                    color: "#b45309",
                    fontSize: "0.88rem",
                    lineHeight: "1.5",
                    boxShadow: "0 2px 10px rgba(217, 119, 6, 0.04)",
                  }}
                  role="alert"
                >
                  <div style={{ display: "flex", gap: "10px", alignItems: "flex-start" }}>
                    <FaShieldAlt size={18} style={{ color: "#d97706", flexShrink: 0, marginTop: "2px" }} />
                    <div>
                      <strong style={{ fontWeight: "700" }}>Safety Disclaimer:</strong> <strong style={{ color: "#d93838", fontWeight: "700" }}>Never pay any amount</strong> for any job. {SYSTEM_NAME} does not charge any fee from applicants and we do not allow employers to charge candidates. If an employer asks you for money or fees, please report the job immediately.
                    </div>
                  </div>
                </div>
              )}

              <Card>
                <CardBody>
                  <h5
                    style={{
                      display: "flex",
                      alignItems: "center",
                      color: "#25D366",
                    }}
                  >
                    <img
                      src={require("../../../assets/images/Icons/whatsapp.png")}
                      width="30px"
                      className="me-2"
                      alt="WhatsApp Icon"
                    />
                    <strong>Join Our WhatsApp Group</strong>
                  </h5>
                  <p>
                    Don't miss out on the latest job updates! Connect with us on
                    WhatsApp and stay ahead in your career.
                  </p>

                  <ul
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                    }}
                  >
                    <li>
                      <a
                        onClick={() =>
                          joinInGroup(
                            "WHATSAPP",
                            "https://chat.whatsapp.com/EjhMlV9z8TSCyiaNd4mSFs"
                          )
                        }
                        href="https://chat.whatsapp.com/EjhMlV9z8TSCyiaNd4mSFs"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <FaArrowRight
                          style={{
                            width: "20px",
                            height: "20px",
                            marginRight: "10px",
                          }}
                        />
                        Xyntara Jobs
                      </a>
                    </li>
                  </ul>
                </CardBody>
              </Card>
              <Card>
                <CardBody>
                  <h5
                    style={{
                      display: "flex",
                      alignItems: "center",
                      color: "#0088cc", // Telegram's brand color
                    }}
                  >
                    <img
                      src={require("../../../assets/images/Icons/telegram.png")} // Assuming you have a Telegram icon
                      width="30px"
                      className="me-2"
                      alt="Telegram Icon"
                    />
                    <strong>Join Our Telegram Group</strong>
                  </h5>
                  <p>
                    Don't miss out on the latest job updates! Connect with us on
                    Telegram and stay ahead in your career.
                  </p>

                  <ul
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                    }}
                  >
                    <li>
                      <a
                        onClick={() =>
                          joinInGroup("TELEGRAM", "https://t.me/India_IT_JOBS")
                        }
                        href="https://t.me/India_IT_JOBS" // Replace with your Telegram group link
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <FaArrowRight
                          style={{
                            width: "20px",
                            height: "20px",
                            marginRight: "10px",
                          }}
                        />
                        India IT Jobs
                      </a>
                    </li>
                    <li>
                      <a
                        onClick={() =>
                          joinInGroup(
                            "TELEGRAM",
                            "https://t.me/Bangalore_Job_Seekers"
                          )
                        }
                        href="https://t.me/Bangalore_Job_Seekers" // Replace with your Telegram group link
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <FaArrowRight
                          style={{
                            width: "20px",
                            height: "20px",
                            marginRight: "10px",
                          }}
                        />
                        Bangalore Jobs
                      </a>
                    </li>
                    <li>
                      <a
                        onClick={() =>
                          joinInGroup(
                            "TELEGRAM",
                            "https://t.me/India_NON_IT_JOBS"
                          )
                        }
                        href="https://t.me/India_NON_IT_JOBS" // Replace with your Telegram group link
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <FaArrowRight
                          style={{
                            width: "20px",
                            height: "20px",
                            marginRight: "10px",
                          }}
                        />
                        India Non IT Jobs
                      </a>
                    </li>
                    <li>
                      <a
                        onClick={() =>
                          joinInGroup(
                            "TELEGRAM",
                            "https://t.me/Hyderabad_Job_Seekers"
                          )
                        }
                        href="https://t.me/Hyderabad_Job_Seekers" // Replace with your Telegram group link
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <FaArrowRight
                          style={{
                            width: "20px",
                            height: "20px",
                            marginRight: "10px",
                          }}
                        />
                        Hyderabad Jobs
                      </a>
                    </li>
                    <li>
                      <a
                        onClick={() =>
                          joinInGroup(
                            "TELEGRAM",
                            "https://t.me/Freshers_Jobs_India"
                          )
                        }
                        href="https://t.me/Freshers_Jobs_India" // Replace with your Telegram group link
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <FaArrowRight
                          style={{
                            width: "20px",
                            height: "20px",
                            marginRight: "10px",
                          }}
                        />
                        Freshers Jobs India
                      </a>
                    </li>
                    <li>
                      <a
                        onClick={() =>
                          joinInGroup("TELEGRAM", "https://t.me/All_India_Jobs")
                        }
                        href="https://t.me/All_India_Jobs" // Replace with your Telegram group link
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <FaArrowRight
                          style={{
                            width: "20px",
                            height: "20px",
                            marginRight: "10px",
                          }}
                        />
                        All India Jobs
                      </a>
                    </li>
                    <li>
                      <a
                        onClick={() =>
                          joinInGroup(
                            "TELEGRAM",
                            "https://t.me/NoidaJobSeekers"
                          )
                        }
                        href="https://t.me/NoidaJobSeekers" // Replace with your Telegram group link
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <FaArrowRight
                          style={{
                            width: "20px",
                            height: "20px",
                            marginRight: "10px",
                          }}
                        />
                        Noida Jobs
                      </a>
                    </li>
                    <li>
                      <a
                        onClick={() =>
                          joinInGroup(
                            "TELEGRAM",
                            "https://t.me/Naukri_Jobs_India"
                          )
                        }
                        href="https://t.me/Naukri_Jobs_India" // Replace with your Telegram group link
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <FaArrowRight
                          style={{
                            width: "20px",
                            height: "20px",
                            marginRight: "10px",
                          }}
                        />
                        Xyntara Jobs India
                      </a>
                    </li>
                  </ul>
                </CardBody>
              </Card>
            </Col>
          </Row>
        ) : jobReducerData.isLoading ? (
          <Spinner />
        ) : (
          <NoDataFound message={"This job is no longer available"} />
        )}
      </Container>
    </Fragment>
  );
};

export default JobDetails;
